var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 16.5H1.5V1.5L16.5 1.5V16.5ZM1.5 17.5H16.5C17.0523 17.5 17.5 17.0523 17.5 16.5V1.5C17.5 0.947715 17.0523 0.5 16.5 0.5H1.5C0.947716 0.5 0.5 0.947715 0.5 1.5V16.5C0.5 17.0523 0.947716 17.5 1.5 17.5Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5894 16.8931V1.10742H11.5894V16.8931H12.5894Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13871 11.782C7.94345 11.9773 7.62686 11.9773 7.4316 11.782L4.64948 8.9999L7.4316 6.21777C7.62686 6.02251 7.94345 6.02251 8.13871 6.21777C8.33397 6.41303 8.33397 6.72961 8.13871 6.92488L6.06369 8.9999L8.13871 11.0749C8.33397 11.2702 8.33397 11.5868 8.13871 11.782Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5718 4.14258C15.5718 3.86644 15.3479 3.64258 15.0718 3.64258H13.8575C13.5813 3.64258 13.3575 3.86644 13.3575 4.14258C13.3575 4.41872 13.5813 4.64258 13.8575 4.64258H15.0718C15.3479 4.64258 15.5718 4.41872 15.5718 4.14258Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5718 6.57153C15.5718 6.29539 15.3479 6.07153 15.0718 6.07153H13.8575C13.5813 6.07153 13.3575 6.29539 13.3575 6.57153C13.3575 6.84768 13.5813 7.07153 13.8575 7.07153H15.0718C15.3479 7.07153 15.5718 6.84768 15.5718 6.57153Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5718 9C15.5718 8.72386 15.3479 8.5 15.0718 8.5H13.8575C13.5813 8.5 13.3575 8.72386 13.3575 9C13.3575 9.27614 13.5813 9.5 13.8575 9.5H15.0718C15.3479 9.5 15.5718 9.27614 15.5718 9Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPanel);
export default __webpack_public_path__ + "static/media/left-panel.3038fa43f24b9e6e5a9f046908da27f4.svg";
export { ForwardRef as ReactComponent };